module.exports = __webpack_public_path__ + "static/media/tab-cover.c45a076e.png";